import { call } from 'redux-saga/effects';
import { FeedMediaStates, RTCClient } from 'utils/webrtc';
import { VirtualBackgroundManager } from 'utils/webrtc/virtual-background/VirtualBackgroundManager';

export function* onBroadcastSetupCancelledSaga() {
  yield call(VirtualBackgroundManager.deactivate);

  const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);
  const preserveAudio = mediaStates.audio.enabled;

  yield call(RTCClient.publishingFeed.configureStreamingState);

  // When a user gets full broadcast permissions after initially broadcasting
  // audio-only, we want to keep their audio enabled rather than reset it.
  // @TODO FIXME find a less hacky way to preserve audio state for this specific case
  if (preserveAudio) {
    yield call(RTCClient.publishingFeed.restoreAudioEnabled);
  }
}
